import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1212e32c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "agents-table--cell" }
const _hoisted_2 = { class: "agents-table--cell-content" }




export default /*#__PURE__*/_defineComponent({
  __name: 'AgentsTableCell',
  props: {
    value: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "default", {}, () => [
        _createTextVNode(_toDisplayString(__props.value), 1)
      ])
    ])
  ]))
}
}

})